import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const Success = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3333 10C18.3333 14.6024 14.6024 18.3333 9.99999 18.3333C5.39762 18.3333 1.66666 14.6024 1.66666 10C1.66666 5.39763 5.39762 1.66667 9.99999 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10ZM13.8939 8.94996C14.2344 8.64037 14.2595 8.11333 13.9499 7.77278C13.6403 7.43224 13.1133 7.40714 12.7728 7.71673L8.77738 11.3489L7.67258 10.2441C7.34714 9.91865 6.8195 9.91865 6.49407 10.2441C6.16863 10.5695 6.16863 11.0972 6.49407 11.4226L8.10455 13.0331C8.45054 13.3791 9.00729 13.3923 9.36935 13.0632L13.8939 8.94996Z"
      fill={color}
    />
  </svg>
);

Success.propTypes = {
  color: string,
  size: number,
};

Success.defaultProps = {
  color: N400,
  size: 20,
};

export default Success;
